import React, { useEffect, useState } from 'react';
import { api } from '../api';
import { t, user } from '../i18n';
import { Spinner, EmptyState, Flash } from '../ui';
import PlaceCard from '../components/PlaceCard';

const bootstrap = window.__P4N__ || {};

export default function Dashboard() {
    const [places, setPlaces] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        api.places()
            .then((data) => setPlaces(data.places))
            .catch((e) => setError(e.message));
    }, []);

    return (
        <>
            <h1 className="page-title">{t('bonjour')} {user ? user.uuid : ''},</h1>
            <hr className="dashed-divider" style={{ marginTop: 12 }} />

            {bootstrap.flash && bootstrap.flash.success && <Flash type="success">{bootstrap.flash.success}</Flash>}
            {bootstrap.flash && bootstrap.flash.error && <Flash type="error">{bootstrap.flash.error}</Flash>}
            {error && <Flash type="error">{error}</Flash>}

            {places === null && !error && <Spinner />}
            {places !== null && places.length === 0 && <EmptyState>{t('no_comment')}</EmptyState>}
            {places !== null && places.map((place) => <PlaceCard key={place.id} place={place} />)}
        </>
    );
}
